'use client';

import { useEffect } from 'react';

/**
 * Registers the PWA service worker in production. In development, registration is
 * skipped to avoid stale caches while iterating (set NEXT_PUBLIC_PWA_DEV=1 to enable).
 */
export default function ServiceWorkerRegister() {
  useEffect(() => {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
    if (process.env.NODE_ENV === 'development' && process.env.NEXT_PUBLIC_PWA_DEV !== '1') {
      return;
    }
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('[PWA] Service worker registration failed:', err);
    });
  }, []);

  return null;
}
